import styled from "styled-components";

export const TableContainer = styled.div`
  overflow-x: auto;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  max-height: 100vh;
`;

export const SwitcherContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
`;

export const Content = styled.div`
    flex: 1;
    overflow: auto;
    min-height: 0;
`;
